<script>
  import { getContext, setContext } from "svelte";
  import { GridContainer, Timeline } from "@ObamaFoundation/of-design-system";

  /** @type { string } */
  let className = "";
  export { className as class };
  export let data;

  const isContainerized = !!getContext("containerized");

  if (!isContainerized) {
    setContext("containerized", true);
  }
</script>

{#if isContainerized}
  <Timeline titleTag="h3" schedules={data} class={className} />
{:else}
  <GridContainer containerClass={className}>
    <Timeline titleTag="h3" schedules={data} />
  </GridContainer>
{/if}
